import { render } from "./sliderComponent.vue?vue&type=template&id=3bc14750&scoped=true"
import script from "./sliderComponent.vue?vue&type=script&lang=js"
export * from "./sliderComponent.vue?vue&type=script&lang=js"

import "./sliderComponent.vue?vue&type=style&index=0&id=3bc14750&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc14750"]])

export default __exports__